import React from 'react';
import { Modal, Button } from '../ui-kit';

const UnsavedChangesWarningModal = props => (
  <Modal show={true} onHide={props.hideUnsavedChangesWarning}>
    <Modal.Header closeButton>
      <Modal.Title> {I18n.t('save_states.unsaved_changes_warning')} </Modal.Title>
    </Modal.Header>
    <Modal.Body> {I18n.t('are_you_sure')} </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={props.hideUnsavedChangesWarning}>
        {I18n.t('cancel')}
      </Button>
      <Button onClick={() => props.exitEditMode(true)} variant="warning">
        {I18n.t('discard_changes')}
      </Button>
      <Button onClick={props.saveChanges} variant="success">
        {I18n.t('save')}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default UnsavedChangesWarningModal;
